module.exports = __webpack_public_path__ + "static/media/search.551964c7.svg";